// extracted by mini-css-extract-plugin
export default {"abs_overlay":"abs_overlay___V4nUO","form":"form___fSQ1P","dark":"dark___j3_jT","link":"link___z3Zen"};